import { FetcherList } from '@garpix/fetcher/fetcher-list/react-router'
import { dataStates } from '@garpix/fetcher'
import Button from '@/components/Button'
import TagButton from '@/components/Button/TagButton'
import BooksCard from '@/components/Cards/BooksCard'
import Container from '@/components/Container'
import Section from '@/components/Section'
import Title from '@/components/Title'
import React from 'react'
import style from '../styles/read.module.scss'
import { IFetcherListResults } from '@/interfaces/Fetcher'
import { api } from '@/api'
import { PlaceholderLoading } from '@/components/PlaceholderLoading'
import useSWR from 'swr'
import NoSearchResults from '@/components/NoSearchResults'

interface IProps {
  role: 'teacher' | 'student'
}

const WhatToRead = ({ role }: IProps): React.ReactElement => {
  const { data } = useSWR('getWhatReadSections', api.getWhatReadSections)

  const initParams = {
    page_size: 5,
    section: '',
    [role]: 1
  }

  return (
    <Section>
      <FetcherList
        initFilter={initParams}
        isScrollTop={false}
        isHistoryPush={false}
        api={api.getWhatRead}
      >
        {({
          results,
          status,
          showMore,
          isNext,
          filterParams,
          loadData
        }: IFetcherListResults<any[]>) => {
          return (
            <Container>
              <Title type='h2' theme='h1' className={style.read__title}>
                Учебно-методическая литература
              </Title>

              {data !== undefined
                ? (
                  <ul className={style.read_tags}>
                    <li className={style.read_tags__item}>
                      <TagButton
                        onClick={() => {
                          loadData(1, {
                            ...filterParams,
                            section: '',
                            [role]: 1
                          })
                        }}
                        active={filterParams.section === ''}
                      >
                        Все
                      </TagButton>
                    </li>
                    {data.results.map((item) => {
                      return (
                        <li key={item.id} className={style.read_tags__item}>
                          <TagButton
                            onClick={() => {
                              loadData(1, {
                                ...filterParams,
                                section: item.id,
                                [role]: 1
                              })
                            }}
                            active={item.id === Number(filterParams.section)}
                          >
                            {item.name}
                          </TagButton>
                        </li>
                      )
                    })}
                  </ul>
                  )
                : null}
              {status === dataStates.loaded && results.length === 0
                ? (
                  <NoSearchResults text='Ничего не найдено' />
                  )
                : null}
              {results.length > 0
                ? (
                  <ul className={style.read_cards}>
                    {results.map((card) => {
                      return (
                        <li className={style.read__card} key={card.id}>
                          <BooksCard
                            id={card.id}
                            image={card.preview_picture?.[0] ?? ''}
                            tag={card.section}
                            title={card.name}
                            link={card.property_link_value}
                          />
                        </li>
                      )
                    })}
                  </ul>
                  )
                : null}
              {status === dataStates.loading
                ? (
                  <ul className={style.read_cards}>
                    <li className={style.read__card}>
                      <PlaceholderLoading
                        shape='rect'
                        width='100%'
                        height='380px'
                      />
                    </li>
                    <li className={style.read__card}>
                      <PlaceholderLoading
                        shape='rect'
                        width='100%'
                        height='380px'
                      />
                    </li>
                    <li className={style.read__card}>
                      <PlaceholderLoading
                        shape='rect'
                        width='100%'
                        height='380px'
                      />
                    </li>
                    <li className={style.read__card}>
                      <PlaceholderLoading
                        shape='rect'
                        width='100%'
                        height='380px'
                      />
                    </li>
                    <li className={style.read__card}>
                      <PlaceholderLoading
                        shape='rect'
                        width='100%'
                        height='380px'
                      />
                    </li>
                  </ul>
                  )
                : null}
              {isNext
                ? (
                  <Button
                    disabled={status === dataStates.loading}
                    onClick={showMore}
                    size='large'
                    wide
                    outline
                    className={style.read__more}
                  >
                    Показать еще
                  </Button>
                  )
                : null}
            </Container>
          )
        }}
      </FetcherList>
    </Section>
  )
}

export default WhatToRead
